import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"; // Open-source version
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; // Open-source version
import { DatePicker } from "@mui/x-date-pickers/DatePicker"; // Open-source version
import TextField from "@mui/material/TextField"; // MUI TextField for the input
import dayjs from "dayjs";
import { toast } from "react-toastify";

export default function BasicDateRangePicker(props) {
  // State to store selected start and end dates
  const {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleGetPrescribedList,
  } = props;

  // Handle date change for start date
  // const handleStartDateChange = (newStartDate) => {
  //   setStartDate(newStartDate);
  // };
  const handleStartDateChange = (newStartDate) => {
    console.log(newStartDate,"::>>newStartDate>>")
    setStartDate(dayjs(newStartDate));
  };

  const handleEndDateChange = (newEndDate) => {
    const startDayjs = dayjs(startDate);
    const endDayjs = dayjs(newEndDate);

    console.log(
      startDayjs.format("YYYY-MM-DD"),
      endDayjs.format("YYYY-MM-DD"),
      "::>> Days"
    );

    if (endDayjs.isBefore(startDayjs, "day")) {
      toast.error("End date cannot be before start date");
      return;
    } else {
      setEndDate(dayjs(newEndDate));
    }
  };

  // const handleEndDateChange = (newEndDate) => {
  //   // Ensure both dates are Day.js objects for proper comparison
  //   const startDayjs = dayjs(startDate);
  //   const endDayjs = dayjs(newEndDate);
  //   console.log(startDayjs, endDayjs, "::>>Dayss>>");
  //   if (endDayjs.isBefore(startDayjs, "day")) {
  //     toast.error("End date cannot be before start date");
  //     return;
  //   } else {
  //     setEndDate(newEndDate);
  //     //   handleGetPrescribedList();
  //   }
  // };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="startDateInput calendarInput">
        {/* Start Date Picker */}
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          renderInput={(params) => <TextField {...params} />}
        />
      </div>
      <div className="calendarInput">
        {/* End Date Picker */}
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          renderInput={(params) => <TextField {...params} />}
          disabled={startDate ? false : true}
        />
      </div>
    </LocalizationProvider>
  );
}
